import script from "./MobileBlocked.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileBlocked.vue?vue&type=script&setup=true&lang=js"

import "./MobileBlocked.vue?vue&type=style&index=0&id=61a172df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a172df"]])

export default __exports__